import React, { useState,useEffect } from 'react';
import './App.css';
import 'bootstrap-italia/dist/css/bootstrap-italia.min.css';
import 'typeface-titillium-web';
import 'typeface-roboto-mono';
import 'typeface-lora';
import { Routes, Route } from "react-router-dom";

import { Home } from "./pages/Home";
import { Whoops404 } from "./pages/Whoops404";

import SibaCalcolaPagaMain from './pages/SibaCalcolaPagaMain';
import SibaConsultazioneMain from './pages/SibaConsultazioneMain';
import SibaEsitoPagamentoMain from './pages/SibaEsitoPagamentoMain';
import SibaPrivacyPolicy from './pages/SibaPrivacyPolicy';

import { SibaRimborsiMain } from "./pages/SibaRimborsiMain";
import { SibaHeader } from './components/common/SibaHeader';
import { SibaFooter } from './components/common/SibaFooter';
import { authenticate } from "./services/endpoints.js";

import * as Constants from "./utils/constants"
import { isUndefined } from './utils/utilities';
import SibaExternalLink from './pages/SibaExternalLink';

function App() {

  const [loading,setLoading] = useState(false);
  useEffect(() => {
    sessionStorage.setItem(Constants.USER_IN_SESSION, undefined);
    loadCurrentUser();
  }, [])

  const loadCurrentUser = async () => {
    let user = await authenticate();
    console.log('App.js user=', user)
    if (user) {
      console.log('App.js user id=', user.user)
      if (!isUndefined(user.user)){
        sessionStorage.setItem(Constants.USER_IN_SESSION, user.user);
        console.log(sessionStorage.getItem(Constants.USER_IN_SESSION));
        setLoading(true)
      }
    }
  }

  return (
    
    <main className="App">
      
      {loading ? (
      <div>  
      <SibaHeader />
        <div>
          <Routes basename={Constants.APP_BASE_NAME}>
            <Route path={Constants.SLASH} element={<Home />} />
            <Route path={Constants.URL_SERVIZI_ONLINE} element={<Home />} />
            <Route path={Constants.URL_SERVIZI_ONLINE_PROTECTED} element={<Home />} />
            <Route path={Constants.URL_CALCOLAPAGA_PUBLIC} element={<SibaCalcolaPagaMain authMode={Constants.AUTH_MODE_PUBLIC} />} />
            <Route path={Constants.URL_ESITOPAGAMENTO_PUBLIC + Constants.STR_ESITO_OK} element={<SibaEsitoPagamentoMain ok={true} authMode={Constants.AUTH_MODE_PUBLIC} />} />
            <Route path={Constants.URL_ESITOPAGAMENTO_PUBLIC + Constants.STR_ESITO_KO} element={<SibaEsitoPagamentoMain ok={false} authMode={Constants.AUTH_MODE_PUBLIC} />} />
            <Route path={Constants.URL_CALCOLAPAGA_PROTECTED} element={<SibaCalcolaPagaMain authMode={Constants.AUTH_MODE_PROTECTED} />} />
            <Route path={Constants.URL_CONSULTAZIONE_PROTECTED} element={<SibaConsultazioneMain authMode={Constants.AUTH_MODE_PROTECTED} />} />
            <Route path={Constants.URL_RIMBORSI_PROTECTED} element={<SibaRimborsiMain authMode={Constants.AUTH_MODE_PROTECTED} />} />
            <Route path={Constants.URL_ESITOPAGAMENTO_PROTECTED + Constants.STR_ESITO_OK} element={<SibaEsitoPagamentoMain ok={true} authMode={Constants.AUTH_MODE_PROTECTED} />} />
            <Route path={Constants.URL_ESITOPAGAMENTO_PROTECTED + Constants.STR_ESITO_KO} element={<SibaEsitoPagamentoMain ok={false} authMode={Constants.AUTH_MODE_PROTECTED} />} />
            <Route path={Constants.URL_ESITOPAGAMENTO_PROTECTED + Constants.STR_ESITO_KO} element={<SibaEsitoPagamentoMain ok={false} authMode={Constants.AUTH_MODE_PROTECTED} />} />
        
            <Route path={Constants.URL_PAGAMENTO_MOD3_PUBLIC} element={<SibaExternalLink targetLink={Constants.URL_EXT_PAGAMENTO_MOD3} />} />
            <Route path={Constants.URL_PRIVACY_POLICY_PUBLIC} element={<SibaPrivacyPolicy />} />
            <Route path="*" element={<Whoops404 />} />
          </Routes>
        </div>
        <SibaFooter />
      </div>) : <div></div>}
      
    </main>
  );
}

export default App;
